import { Localized } from "@fluent/react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks"
import { updateCounterparty } from "../documentsApi";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";
import { CounterpartySelect } from "../../counterparty/CounterpartySelect";

export interface EditDocumentCounterpartyDialogProps {
    documentId: AppId
    value: string
    onSuccess: (newValue: string) => void
    onCancel: () => void
}

export const EditDocumentCounterpartyDialog = (props: EditDocumentCounterpartyDialogProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [value, setValue] = useState(props.value)

    const handleOkClick = () => {
        setSaving(true)
        dispatch(updateCounterparty({
            documentId: props.documentId,
            counterpartyId: value.trim() === "" ? null : value,
        }))
            .then(unwrapResult)
            .then(() => { props.onSuccess(value) })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setSaving(false)
            })
    }

    return <Dialog open={true} fullWidth maxWidth='md'>
        <DialogTitle sx={{
            bgcolor: (theme) => theme.palette.grey[200],
            borderBottom: "1px solid",
            borderColor: "divider",
            py: 0.75,
        }}>
            <Localized id='edit'>_Edycja</Localized>
        </DialogTitle>
        <DialogContent>
            <CounterpartySelect
                value={value}
                onChange={setValue}
                disabled={saving}
                label={<Localized id="counterparties-select-label"><span>_Kontrahent</span></Localized>}
            />
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleOkClick} />
            <CloseButton loading={saving} onClick={props.onCancel} />
        </DialogActions>
    </Dialog>
}
